var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFacebookWhile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.331,
    height: 21.202,
    viewBox: "0 0 21.331 21.202",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-facebook",
    "data-name": "Icon awesome-facebook",
    d: "M21.894,11.228A10.666,10.666,0,1,0,9.562,21.765V14.311H6.852V11.228H9.562V8.878c0-2.673,1.591-4.149,4.028-4.149a16.414,16.414,0,0,1,2.388.208V7.56H14.632a1.542,1.542,0,0,0-1.738,1.666v2h2.958l-.473,3.083H12.895v7.453A10.669,10.669,0,0,0,21.894,11.228Z",
    transform: "translate(-0.563 -0.563)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFacebookWhile);
export default __webpack_public_path__ + "static/media/icon-facebook-while.b945210bef46c5ff6fb224a7202ca7e7.svg";
export { ForwardRef as ReactComponent };